import React, { useMemo } from 'react';
import { useLucideIcons } from '../../hooks/usePageAssets.js';

const typeLabels = {
  articulos: { label: 'Artículos', icon: 'package' },
  recetas: { label: 'Recetas', icon: 'chef-hat' },
  azucar_glass: { label: 'Azúcar Glass', icon: 'snowflake' },
  warmer: { label: 'Warmer', icon: 'flame' }
};

const ProcessSelector = ({ sections, selected, onToggle, disabled, emptyMessage }) => {
  const iconDeps = useMemo(
    () => (sections || []).map((section) => `${section.type}:${section.processes?.length || 0}`).join('|'),
    [sections]
  );
  useLucideIcons([iconDeps]);

  if (!sections || sections.length === 0) {
    return <p className="loading-text">{emptyMessage || 'Seleccione un restaurante para ver los procesos...'}</p>;
  }

  const renderHeader = (type) => {
    const meta = typeLabels[type] || { label: type, icon: 'list' };
    return (
      <div className="process-type-header">
        <h4 className="process-type-title">
          <i data-lucide={meta.icon} /> {meta.label}
        </h4>
      </div>
    );
  };

  return sections.map((section) => (
    <div className="process-type-section" key={section.type}>
      {renderHeader(section.type)}
      <div className="checkbox-grid">
        {section.processes.map((process) => (
          <label className="checkbox-item" key={process.proceso}>
            <input
              type="checkbox"
              name="procesos"
              value={process.proceso}
              data-tipo={process.proceso_es_warmer
                ? 'warmer'
                : (process.proceso_es_azucar_glass ? 'azucar_glass' : (process.proceso_tipo || 'articulos'))}
              checked={selected.has(process.proceso)}
              disabled={disabled}
              onChange={() => onToggle(process.proceso)}
            />
            <span className="checkmark" />
            <span className="checkbox-label">{process.proceso}</span>
          </label>
        ))}
      </div>
    </div>
  ));
};

export default ProcessSelector;
